import React, { useState, useEffect } from 'react'
import { supabase } from '../supabaseClient'
import SidebarLayout from '../components/SidebarLayout'
import { Link } from 'react-router-dom'


const alphabet = ['All', ...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')]

const PlansByGroupPage = () => {
  const [selectedLetter, setSelectedLetter] = useState('All')
  const [search, setSearch] = useState('')
  const [allPlans, setAllPlans] = useState([])
  const [plans, setPlans] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const fetchPlans = async () => {
      setLoading(true)
      const { data, error } = await supabase
        .from('plans_test')
        .select('group_name, group_id, benefit_year, last_upload_date')
        .order('group_name', { ascending: true })

      console.log('Fetched data:', data)
      if (!error && data) {
        setAllPlans(data)
      }

      setLoading(false)
    }

    fetchPlans()
  }, [])

  useEffect(() => {
    const filtered = allPlans.filter((plan) => {
      const rawName = plan.group_name || ''
      const name = rawName.trim().toLowerCase()
      const searchTerm = search.trim().toLowerCase()

      if (searchTerm) {
        return name.includes(searchTerm)
      } else if (selectedLetter === 'All') {
        return true
      } else {
        return name.startsWith(selectedLetter.toLowerCase())
      }
    })

    setPlans(filtered)
  }, [selectedLetter, search, allPlans])

  return (
    <SidebarLayout>
      <div
        style={{
          padding: '2rem',
          backgroundColor: '#f1f5f9',
          minHeight: '100vh',
        }}
      >
        <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
          🗂 Plans by Group Name
        </h2>

        {/* Search Box */}
        <input
          type="text"
          placeholder="Search group name..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{
            padding: '0.5rem',
            marginBottom: '1rem',
            width: '100%',
            maxWidth: '400px',
            borderRadius: '4px',
            border: '1px solid #ccc',
          }}
        />

        {/* Alphabet Filter */}
        <div style={{ marginBottom: '1.5rem' }}>
          {alphabet.map((letter) => (
            <button
              key={letter}
              onClick={() => setSelectedLetter(letter)}
              style={{
                marginRight: '0.5rem',
                padding: '0.25rem 0.6rem',
                borderRadius: '4px',
                backgroundColor:
                  selectedLetter === letter ? '#3b82f6' : '#e2e8f0',
                color: selectedLetter === letter ? '#fff' : '#1f2937',
                border: 'none',
                cursor: 'pointer',
              }}
            >
              {letter}
            </button>
          ))}
        </div>

        {/* Results */}
        {loading ? (
          <p>Loading plans...</p>
        ) : plans.length === 0 ? (
          <p>
            No plans found{selectedLetter !== 'All' && ` for “${selectedLetter}”`}
            {search && ` with search: “${search}”`}
          </p>
        ) : (
          <ul style={{ listStyle: 'none', padding: 0 }}>
              {plans.map((plan, idx) => (
              <li
              key={idx}
              style={{
              padding: '0.5rem 0',
              borderBottom: '1px solid #e5e7eb',
              }}
              >
            <Link
              to={`/view-plan/group/${encodeURIComponent(plan.group_id)}`}
              style={{
              fontSize: '1rem',
              color: '#0f172a',
              textDecoration: 'none',
              display: 'block',
              }}
             >
            <strong>
              {plan.benefit_year
              ? `${plan.group_name} (${plan.benefit_year})`
              : plan.group_name}
              </strong>{' '}
            <span style={{ color: '#6b7280', fontSize: '0.85rem' }}>
              (Group ID: {plan.group_id})
            </span>
          </Link>
          </li>
          ))}
        </ul>
        )}
      </div>
    </SidebarLayout>
  )
}

export default PlansByGroupPage
